"use client";

import Countdown from './Countdown';
import Statistic from './Statistic';
import Timer from './Timer';
Statistic.Timer = Timer;
Statistic.Countdown = Countdown;
export default Statistic;